var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWarningDelete = function SvgWarningDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "25px",
    viewBox: "0 0 26 25",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "warning-svgrepo-com")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "admin_users_settings_delete_user-02",
    transform: "translate(-471.000000, -308.000000)",
    fill: "#1C2243",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(436.000000, 265.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(35.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warning-svgrepo-com",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0146916,17.6129032 C12.3223123,17.6129032 11.7419355,18.1865806 11.7419355,18.8709677 C11.7419355,19.5553548 12.3223123,20.1290323 13.0146916,20.1290323 C13.6816158,20.1290323 14.2874477,19.5553548 14.2569015,18.9011613 C14.2874477,18.1815484 13.7121619,17.6129032 13.0146916,17.6129032 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3673068,21.9379067 C26.2064246,20.4556896 26.2117693,18.6890619 25.3779962,17.2123142 L17.0081963,2.37920454 C16.1797679,0.886048587 14.6832519,0 13.0050162,0 C11.3267805,0 9.83026456,0.891518022 9.0018361,2.3737351 L0.621346879,17.2232531 C-0.212426283,18.716409 -0.207081584,20.4939756 0.637380978,21.9761927 C1.47115414,23.4420015 2.96232537,24.3225806 4.6298717,24.3225806 L21.3480925,24.3225806 C23.0209836,24.3225806 24.5228442,23.4310626 25.3673068,21.9379067 Z M23.5501088,20.8658973 C23.08512,21.6863126 22.2620362,22.1730924 21.3427478,22.1730924 L4.624527,22.1730924 C3.71592804,22.1730924 2.89818898,21.6972515 2.4438895,20.8932444 C1.98424532,20.0782985 1.97890062,19.104739 2.4385448,18.2843236 L10.819034,3.44027507 C11.2733335,2.62532915 12.0857279,2.1440188 13.0050162,2.1440188 C13.9189599,2.1440188 14.7366989,2.63079858 15.1909984,3.4457445 L23.5661429,18.289793 C24.0150977,19.0883307 24.009753,20.0509513 23.5501088,20.8658973 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7035452,6.74688241 C12.1106356,6.92610988 11.7419355,7.49542069 11.7419355,8.18597361 C11.7718301,8.60241392 11.7967423,9.02412562 11.8266369,9.44056593 C11.9113382,11.0272562 11.9960396,12.5823181 12.080741,14.1690084 C12.1106356,14.7066909 12.5042478,15.0967742 13.0124561,15.0967742 C13.5206643,15.0967742 13.919259,14.6803339 13.9441712,14.1373801 C13.9441712,13.8105535 13.9441712,13.5100839 13.9740658,13.1779859 C14.0288726,12.1606064 14.0886618,11.1432269 14.1434685,10.1258475 C14.1733631,9.46692291 14.2281699,8.80799837 14.2580645,8.14907383 C14.2580645,7.911861 14.2281699,7.70100514 14.1434685,7.49014929 C13.8893644,6.8997529 13.2964548,6.59928331 12.7035452,6.74688241 Z",
    id: "Path"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWarningDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning-delete.33357364.svg";
export { ForwardRef as ReactComponent };